// <html lang>: the page's language, from its URL prefix (/bg/… → bg)
export default (pageContext) => pageContext.metadata?.language || pageContext.urlPathname?.match(/^\/([a-z]{2})(\/|$)/)?.[1] || "en"
